import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { zodResolver } from '@hookform/resolvers/zod'

import { useHttpClient } from '@/modules/shared/hooks/use-http-client'
import { authRegisterService } from '../services/auth-register.service'
import {
  type AuthRegisterSchema,
  authRegisterSchema
} from '../schemas/auth-register.schema'

export function useAuthRegister() {
  const navigate = useNavigate()

  const form = useForm<AuthRegisterSchema>({
    resolver: zodResolver(authRegisterSchema),
    defaultValues: {
      accessCode: '',
      name: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
    },
  })

  const httpClient = useHttpClient(
    authRegisterService,
    {
      onSuccess: (response) => {
        if (response.status === 200) {
            navigate('/login')
        }
      },
      showToast: true,
    }
  )

  const submitAuthRegister = useCallback((data: AuthRegisterSchema) => {
    httpClient.execute({
			name: data.name,
      email: data.email,
      lastName: data.lastName,
      accessCode: data.accessCode,
      password: data.confirmPassword, })
  }, [httpClient])

  return {
    form,
    isLoading: httpClient.isLoading,
    error: httpClient.error,
    submitAuthRegister,
  }
}